module.exports = __webpack_public_path__ + "static/media/ios-male.d01fb1a1.svg";